import { useEffect, useRef } from "react";
import { useApiClient } from "../../../api";
import { useAuthenticationStore } from "../../../stores/auth";

export const useAnswerViewTracking = (studentAnswer) => {
  const ApiClient = useApiClient();
  const { user, impersonation } = useAuthenticationStore();
  const lastViewedRef = useRef(null);

  useEffect(() => {
    if (!studentAnswer || studentAnswer?.status !== "MARKED") return;
    if (lastViewedRef.current === studentAnswer.id) return;
    if (user?.beingImpersonated || impersonation?.isActive) return;

    const timer = setTimeout(async () => {
      try {
        await ApiClient.assignment.recordAnswerView({
          answer: studentAnswer.id,
        });
        lastViewedRef.current = studentAnswer.id;
      } catch (error) {
        console.error("Failed to record view", error);
      }
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, [
    studentAnswer?.id,
    ApiClient,
    user?.beingImpersonated,
    impersonation?.isActive,
  ]);
};
